// Add entries here as each hub page is converted to the public-split architecture.
const SLUG_TO_PRODUCT_GROUP = {
  content: 'CONTENT'
};
export function getProductGroupBySlug(slug) {
  return SLUG_TO_PRODUCT_GROUP[slug.toLowerCase()];
}